<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    formControlName="arbitrageType"
                    direction="column"
                    [isDefault]="false"
                    [options]="getArbitrageTypeOptions(product)"
                    columns="1"
                  >
                  </pr-input-radio>
                </div>
              </div>
            </ng-container>
            @if (isArbitrageWithFlux(product)) {
              <info [option]="{ icon: 'warning' }"
                >Attention: le flux est désinvesti en totalité par défaut
              </info>
            }
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
